/** RFC 4122 UUID string (case-insensitive). */
const INQUIRY_LEAD_ID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const isValidInquiryLeadId = (value: string): boolean =>
  INQUIRY_LEAD_ID_PATTERN.test(value);
